import { superEnhancementKeys } from './superEnhancement/superEnhancementKeys';
import type { QueryClient } from '@tanstack/react-query';
import { adminJobsKeys } from './adminJobs/adminJobsKeys';
import { billingKeys } from './billing/billingKeys';
import { cancelAndInvalidateQueries } from './cancelAndInvalidateQueries';

export const invalidateAdminJobDetails = (queryClient: QueryClient, jobId: string) =>
  Promise.all([
    cancelAndInvalidateQueries(queryClient, adminJobsKeys.detail(jobId)),
    cancelAndInvalidateQueries(queryClient, adminJobsKeys.domains(jobId)),
    cancelAndInvalidateQueries(queryClient, superEnhancementKeys.detail(jobId)),
    cancelAndInvalidateQueries(queryClient, superEnhancementKeys.messages(jobId)),
    cancelAndInvalidateQueries(queryClient, adminJobsKeys.enhancementsByJob(jobId)),
    cancelAndInvalidateQueries(queryClient, adminJobsKeys.licenseUsageByJob(jobId)),
    cancelAndInvalidateQueries(queryClient, adminJobsKeys.pipelineStatusByJob(jobId)),
    cancelAndInvalidateQueries(queryClient, adminJobsKeys.attemptsByJob(jobId)),
    cancelAndInvalidateQueries(queryClient, adminJobsKeys.attemptDetails()),
  ]);

export const invalidateBillingData = (queryClient: QueryClient) =>
  Promise.all([
    cancelAndInvalidateQueries(queryClient, billingKeys.accounts()),
    cancelAndInvalidateQueries(queryClient, billingKeys.paymentMethods()),
    cancelAndInvalidateQueries(queryClient, billingKeys.transactions()),
    cancelAndInvalidateQueries(queryClient, billingKeys.accountLists()),
  ]);
